<script setup>
import { ref } from 'vue'

const { user, tagEvent, displayAlert } = defineProps({
	user: Object,
	tagEvent: Function,
	displayAlert: Function,
});

const email = ref('');
const reason = ref('issue');
const message = ref("");
let errorMessage = "";

if (!email.value && user?.email) {
	email.value = user.email
}

async function sendMessage() {
	if (!(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email.value))) { return; }

	errorMessage = ""; // Clear previous errors
	const form = document.getElementById('contactForm');
	form.classList.add('sending');
	var teamId = '696e197ca8355e61ab921179';
	var formId = '69c60c86facc66aa5923a189';

	try {
		const response = await fetch(`/api/mailbox/${teamId}/contact/${formId}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: email.value.trim(),
				'custom:reason': reason.value.trim(),
				message: message.value.trim(),
				form: 'study',
				formId
			}),
		});

		const data = await response.json();
		console.log(response);

		if (!response.ok) {
			throw new Error(data.error || "Message couldn't be sent");
		}

		/* SUCCESS */
		console.log("Message Sent:", data);
		displayAlert('Message received', 'If you need to provide additional information, you can reply to the confirmation email.', 'success');
		form.classList.remove('sending');
		/* END SUCCESS */
	} catch (error) {
		/* FAILURE */
		errorMessage = error.message;
		console.error("Message error:", error);
		displayAlert('Something went wrong', ['There was a problem sending your message.', 'Please send us an email instead: <a href="mailto:hello@brownjuice.co">hello@brownjuice.co</a>'], 'error', 'Okay');
		form.classList.remove('sending');
		/* END FAILURE */
	}
}
</script>

<template>
<section id="contact-form" class="contain">
	<form id="contactForm">
		<label rel="reason"><span>Reason for Contact</span></label>
		<div id="reason" name="reason">
			<label>
				<input type="radio" name="reason" v-model="reason" value="issue" checked hidden />
				<span>Report Issues</span>
			</label>
			<label>
				<input type="radio" name="reason" v-model="reason" value="feedback" hidden />
				<span>Feedback</span>
			</label>
			<label>
				<input type="radio" name="reason" v-model="reason" value="inquiry" hidden />
				<span>General Inquiry</span>
			</label>
		</div>
		<label rel="email"><span>Email Address</span></label>
		<input type="email" name="email" v-model="email" :placeholder="this.user?.email" autocomplete="email" required/>
		<label rel="message"><span>Message</span></label>
		<textarea name="message" v-model="message" rows="5.5" placeholder="Enter your message..." autocomplete="off" required></textarea>
		<button @click.stop.prevent="sendMessage" type="submit" class="btn primary wide" id="sendButton">Send Message</button>
		<p v-if="errorMessage" style="color: red">{{ errorMessage }}</p>
	</form>

	<div id="confirmation" class="hidden"></div>
</section>
</template>

<style lang='scss' scoped>
label[rel] {
	display:block;
	margin-bottom:.5rem;
}
#contact-form input, #contact-form select, #contact-form textarea, #reason {
	background-color:var(--bg1);
	border:1px solid var(--border);
	border-radius:8px;
	font-family:inherit!important;
	margin-bottom:1rem;
}
#contact-form input:placeholder-shown, #contact-form select:placeholder-shown, #contact-form textarea:placeholder-shown {
	background-color:var(--bg2);
}
#contact-form input:focus, #contact-form select:focus, #contact-form textarea:focus {
	background-color:var(--bg1);
	border-color:var(--border-field-outline);
	outline:1px solid var(--border-field-outline);
	outline-offset:0;
}
#contact-form textarea {
	resize:vertical;
	line-height:1.5em;
}
#reason {
	display:flex;
	flex-flow:column;
	justify-content:stretch;
	padding:4px;
	gap:5px;
}
#reason label {
	border-radius:4px;
	margin-bottom:0;
	cursor:pointer;
	padding:calc(.5rem - 3px);
	text-align:center;
}
@media(min-width:768px) {
	#reason {flex-flow:row;}
	#reason label {width:33%;}
}
#reason label:has(:checked) {
	background-color:var(--interactive);
	color:var(--text1);
	font-weight:700;
}
#reason label:not(:has(:checked)):hover {
	background-color:var(--nav-hover);
	color:var(--text1);
}
#reason input {
	display:none;
}
#reason ~ label {
	display:block;
	margin-bottom:6px;
}
#contact-form input.error, #contact-form select.error, #contact-form textarea.error {
	border:2px solid var(--border-warning);
}
#confirmation {
	text-align:center;
	font-size:1.2rem;
}
.error-message {
	display:none;
	color:var(--border-warning);
	font-size:0.9rem;
}
.error ~ .error-message {
	display:block;
}
</style>
